const replaceTags = text => text
// Remove all wrappers opening div tags with class "trix-content" and closing div tags
.replace(/<div class="trix-content">/gi, '')
.replace(/<\/div>/gi, '')
// Remove br tag that are not enclosed within other HTML tags, plain text
.replace(/(?<=^|>)(\s*<br\/>\s*|<br>\s*)+(?=<|$)/gi, '')
// Remove br tag that are directly before strong tag and after its closing tag
.replace(/<\/strong>\s*(<br\/>\s*|<br>\s*)+/gi, '</strong>')
// Remove br tags that are directly before opening strong tags
.replace(/(<br\/>\s*|<br>\s*)+<strong>/gi, '<strong>')
// Replace opening strong tags with opening h3 tags with class "career-offer-item-header"
.replace(/<strong>/gi, '<h3 class="career-offer-item-header"><strong>')
.replace(/<\/strong>/gi, '</strong></h3>')

export default replaceTags;
